import {Close} from '@mui/icons-material'
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from '@mui/material'
import Button from '@mui/material/Button'
import React from 'react'
import styled from 'styled-components'
import {ThemeColorsHospitalic} from '@/assets/styles/color/ThemeColorsHospitalic'

const StyledDialogActions = styled(DialogActions)`
    background-color: #00000040;
`

const StyledHeader = styled.div`
  background: linear-gradient(to top, #FFFFFF, ${ThemeColorsHospitalic.PRIMARY_LIGHT} 75%);
  border-bottom: 1px solid ${ThemeColorsHospitalic.NEUTRAL_MEDIUM};
`

const StyledButton = styled(Button)`
    color: ${ThemeColorsHospitalic.PRIMARY_DARK};
`

type DetailDialogProps = {
    header: string;
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
}

const DetailDialog = ({header, open, onClose, children}: DetailDialogProps) => {
    return (
        <Dialog
            fullWidth
            maxWidth='xl'
            open={open}
            onClose={onClose}
            aria-describedby="applied-dataset-filter-dialog"
        >
            <StyledHeader>
                <DialogTitle variant='h5'>{header}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: ThemeColorsHospitalic.PRIMARY_DARK,
                    }}
                >
                    <Close/>
                </IconButton>
            </StyledHeader>
            <DialogContent>
                {children}
            </DialogContent>
            <StyledDialogActions>
                <StyledButton onClick={onClose} variant="outlined" size="small">Close</StyledButton>
            </StyledDialogActions>
        </Dialog>
    )
}

export default DetailDialog